import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'sonner';
import axios from 'axios';
import { Zap, Mail, Lock, Eye, EyeOff } from 'lucide-react';

import { getBackendUrl } from '../../services/origin';
const API = getBackendUrl();

export default function SuperadminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const { adminLogin } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) { toast.error('Compila tutti i campi'); return; }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/api/auth/admin/login`, { email, password });
      if (res.data.admin.role !== 'superadmin') {
        toast.error('Accesso riservato al superadmin Lazo');
        setLoading(false);
        return;
      }
      adminLogin(res.data.token, res.data.admin);
      toast.success('Benvenuto in Lazo!');
      navigate('/superadmin');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Credenziali non valide');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0F172A] flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#D44E20] to-[#F59E0B] flex items-center justify-center mx-auto mb-4 shadow-lg shadow-[#D44E20]/20">
            <Zap size={32} className="text-white" />
          </div>
          <h1 className="text-2xl font-bold text-white tracking-tight">Lazo</h1>
          <p className="text-[#64748B] text-sm mt-1">Pannello Superadmin</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="bg-[#1E293B] rounded-2xl p-6 border border-[#334155] space-y-4">
          <div>
            <label className="block text-xs font-medium text-[#94A3B8] mb-1.5">Email</label>
            <div className="relative">
              <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#64748B]" />
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                data-testid="sa-login-email"
                placeholder="admin@lazo.app"
                className="w-full h-11 pl-10 pr-3 bg-[#0F172A] border border-[#334155] rounded-xl text-white text-sm focus:outline-none focus:ring-2 focus:ring-[#D44E20]/30 focus:border-[#D44E20] transition-all placeholder:text-[#475569]"
              />
            </div>
          </div>
          <div>
            <label className="block text-xs font-medium text-[#94A3B8] mb-1.5">Password</label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#64748B]" />
              <input
                type={showPw ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                data-testid="sa-login-password"
                className="w-full h-11 pl-10 pr-10 bg-[#0F172A] border border-[#334155] rounded-xl text-white text-sm focus:outline-none focus:ring-2 focus:ring-[#D44E20]/30 focus:border-[#D44E20] transition-all"
              />
              <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-3 top-1/2 -translate-y-1/2 text-[#64748B] hover:text-[#94A3B8]">
                {showPw ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="sa-login-btn"
            className="w-full h-11 bg-gradient-to-r from-[#D44E20] to-[#F59E0B] text-white font-semibold rounded-xl hover:opacity-90 disabled:opacity-50 transition-all text-sm"
          >
            {loading ? 'Accesso...' : 'Accedi'}
          </button>
        </form>

        <p className="text-center text-[#475569] text-xs mt-6">
          Sei un operatore? <a href="/admin/login" className="text-[#D44E20] hover:text-[#F59E0B] transition-colors">Accedi come brand</a>
        </p>
      </div>
    </div>
  );
}
